import Axios from '../../library/Axios'

export const LoginPostAction = (mobile: string, password: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'LOGIN_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/login`, {
            mobile: mobile,
            password: password
        })

        dispatch({ type: 'LOGIN_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'LOGIN_POST_ERROR' })
    } finally {
        dispatch({ type: 'LOGIN_POST_RESET' })
    }
}

export const RegisterPostAction = (name: string, family: string, mobile: string, birth_date: string, password: string, reagent_code: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'REGISTER_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/register`, {
            name: name,
            family: family,
            mobile: mobile,
            birth_date: birth_date,
            password: password,
            reagent_code: reagent_code
        })

        dispatch({ type: 'REGISTER_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'REGISTER_POST_ERROR' })
    } finally {
        dispatch({ type: 'REGISTER_POST_RESET' })
    }
}

export const ActivationAccountPostAction = (uid: string, activation_code: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'ACTIVATION_ACCOUNT_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/activation`, {
            uid: uid,
            activation_code: activation_code
        });

        dispatch({ type: 'ACTIVATION_ACCOUNT_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'ACTIVATION_ACCOUNT_POST_ERROR' })
    } finally {
        dispatch({ type: 'ACTIVATION_ACCOUNT_POST_RESET' })
    }
}

export const SendActivationPostAction = (uid: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'SEND_ACTIVATION_CODE_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/send_activation_code`, {
            uid: uid
        });

        dispatch({ type: 'SEND_ACTIVATION_CODE_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'SEND_ACTIVATION_CODE_POST_ERROR' })
    }
}

export const PasswordRecoveryPostAction = (mobile: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'PASSWORD_RECOVERY_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/password_recovery`, { mobile: mobile })

        dispatch({ type: 'PASSWORD_RECOVERY_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'PASSWORD_RECOVERY_POST_ERROR' })
    } finally {
        dispatch({ type: 'PASSWORD_RECOVERY_POST_RESET' })
    }
}

export const DepositPostAction = (amount: string, tracking_code: string, card_number: string, date: string, transfer_type: string, project_id: number = 0, mobile: string = '', full_name: string = '', anonymous: boolean = false, anonymous_price: boolean = false, anonymous_profile: boolean = false, pay_do?: string, seedling_type?: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'DEPOSIT_POST_REQUEST' })

        let params: any = {
            amount: amount,
            tracking_code: tracking_code,
            card_number: card_number,
            date: date,
            transfer_type: transfer_type,
            project_id: project_id,
            full_name: full_name,
            mobile: mobile,
            anonymous: anonymous,
            anonymous_price: anonymous_price,
            anonymous_profile: anonymous_profile,
        }

        if (seedling_type != "") {
            params["seedling_type"] = seedling_type;
        }

        if (pay_do != "") {
            params["pay_do"] = pay_do;
        }

        const { data } = await new Axios().post(`/post/submit/deposit`, params)

        dispatch({ type: 'DEPOSIT_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'DEPOSIT_POST_ERROR' })
    } finally {
        dispatch({ type: 'DEPOSIT_POST_RESET' })
    }
}

export const AidPostAction = (action: string, obligation: string, amount: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'AID_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/submit/aid`, {
            action: action,
            obligation: obligation,
            amount: Number(amount)
        })

        dispatch({ type: 'AID_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'AID_POST_ERROR' })
    } finally {
        dispatch({ type: 'AID_POST_RESET' })
    }
}

export const ChangePasswordPostAction = (current_password: string, new_password: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'CHANGE_PASSWORD_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/user/change/password`, {
            current_password: current_password,
            new_password: new_password
        })

        dispatch({ type: 'CHANGE_PASSWORD_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'CHANGE_PASSWORD_POST_ERROR' })
    } finally {
        dispatch({ type: 'CHANGE_PASSWORD_POST_RESET' })
    }
}

export const UserDataAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'USER_DATA_REQUEST' })

        const { data } = await new Axios().get(`/get/user/data`)

        dispatch({
            type: 'USER_DATA_SUCCESS', payload: data
        })
    } catch (error) {
        dispatch({ type: 'USER_DATA_ERROR' })
    } finally {
        dispatch({ type: 'USER_DATA_RESET' })
    }
}

export const CheckAidAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'CHECK_AID_REQUEST' })

        const { data } = await new Axios().get(`/get/user/check/aid`)

        dispatch({
            type: 'CHECK_AID_SUCCESS', payload: data
        })
    } catch (error) {
        dispatch({ type: 'CHECK_AID_ERROR' })
    }
}

export const RequestCardPostAction = (action: string, name: string, family: string, gender: string, province: string, city: string, national_code: string, address: string, postal_code: string, education_level: string, field_study: string, job: string, martial: string, website: string, instagram: string, other: string, cooperation: string, research: string, public_relations: string, religious: string, developmental: string, graphics: string, veterinary: string, ladies: string, children: string, legal: string, documentation: string, aid_amount: string) => async (dispatch: any) => {
    try {
        dispatch({ type: 'REQUEST_CARD_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/submit/card`, {
            action: action,
            name: name,
            family: family,
            gender: gender,
            province: province,
            city: city,
            national_code: national_code,
            address: address,
            postal_code: postal_code,
            education_level: education_level,
            field_study: field_study,
            job: job,
            martial: martial,
            website: website,
            instagram: instagram,
            other: other,
            cooperation: cooperation,
            research: research,
            public_relations: public_relations,
            religious: religious,
            developmental: developmental,
            graphics: graphics,
            veterinary: veterinary,
            ladies: ladies,
            children: children,
            legal: legal,
            documentation: documentation,
            aid_amount: parseInt(aid_amount)
        })

        dispatch({ type: 'REQUEST_CARD_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'REQUEST_CARD_POST_ERROR' })
    } finally {
        dispatch({ type: 'REQUEST_CARD_POST_RESET' })
    }
}

export const UploadImagePostAction = (type: string, image: any, x: string, y: string, width: string, height: string) => async (dispatch: any) => {
    try {
        if (type == 'avatar') {
            dispatch({ type: 'UPLOAD_AVATAR_REQUEST' })
        } else if (type == 'national_card') {
            dispatch({ type: 'UPLOAD_NATIONAL_CARD_REQUEST' })
        }

        const formData = new FormData();
        formData.append("image", image, image.name);
        formData.append("x", x);
        formData.append("y", y);
        formData.append("width", width);
        formData.append("height", height);

        const { data } = await new Axios().post(`/post/upload/${type}`, formData);

        if (type == 'avatar') {
            dispatch({ type: 'UPLOAD_AVATAR_SUCCESS', payload: data })
        } else {
            dispatch({ type: 'UPLOAD_NATIONAL_CARD_SUCCESS', payload: data })
        }
    } catch (error) {
        // console.log(error)
    }
}

export const UploadAttachPostAction = (file: any) => async (dispatch: any) => {
    try {
        dispatch({ type: 'UPLOAD_ATTACH_REQUEST' })

        const formData = new FormData();
        formData.append("file", file);

        const { data } = await new Axios().post(`/post/upload/file`, formData);

        dispatch({ type: 'UPLOAD_ATTACH_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'UPLOAD_ATTACH_ERROR' })
    }
}

export const OrderListGetAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'ORDER_LIST_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/user/orders`)

        dispatch({ type: 'ORDER_LIST_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'ORDER_LIST_GET_ERROR' })
    }
}

export const OrderDetailGetAction = (order_id: any) => async (dispatch: any) => {
    try {
        dispatch({ type: 'ORDER_DETAIL_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/user/order/${order_id}`)

        dispatch({ type: 'ORDER_DETAIL_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'ORDER_DETAIL_GET_ERROR' })
    }
}

export const PaymentsGetAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'PAYMENT_LIST_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/user/payments`)

        dispatch({ type: 'PAYMENT_LIST_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'PAYMENT_LIST_GET_ERROR' })
    } finally {
        // dispatch({ type: 'ORDER_DETAIL_GET_RESET' })
    }
}

export const MessageListGetAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'MESSAGE_LIST_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/user/messages`)

        dispatch({ type: 'MESSAGE_LIST_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'MESSAGE_LIST_GET_ERROR' })
    } finally {
        // dispatch({ type: 'MESSAGE_DETAIL_GET_RESET' })
    }
}

export const MessageViewGetAction = (id: any) => async (dispatch: any) => {
    try {
        dispatch({ type: 'MESSAGE_VIEW_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/user/messages/${id}`)

        dispatch({ type: 'MESSAGE_VIEW_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'MESSAGE_VIEW_GET_ERROR' })
    } finally {
        // dispatch({ type: 'MESSAGE_DETAIL_GET_RESET' })
    }
}

export const SubmitMessagePostAction = (ticket_id: string, subject: string, message: string, attach: any = null) => async (dispatch: any) => {
    try {
        dispatch({ type: 'SUBMIT_MESSAGE_POST_REQUEST' })

        const formData = new FormData();
        formData.append("attach", attach);
        formData.append("ticket_id", ticket_id);
        formData.append("subject", subject);
        formData.append("message", message);

        const { data } = await new Axios().post(`/post/submit/message`, formData);

        dispatch({ type: 'SUBMIT_MESSAGE_POST_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'SUBMIT_MESSAGE_POST_ERROR' })
    } finally {
        dispatch({ type: 'SUBMIT_MESSAGE_POST_RESET' })
    }
}

export const FundGetAction = () => async (dispatch: any) => {
    try {
        dispatch({ type: 'FUND_GET_REQUEST' })

        const { data } = await new Axios().get(`/get/funds`)

        dispatch({ type: 'FUND_GET_SUCCESS', payload: data })
    } catch (error) {
        dispatch({ type: 'FUND_GET_ERROR' })
    }
}